import { oc } from '@orpc/contract'
import { z } from 'zod'

export const taskCommentSchema = z.object({
  id: z.string().min(1),
  taskId: z.string().min(1),
  authorId: z.string().min(1),
  authorName: z.string(),
  content: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const taskCommentsListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(taskCommentSchema),
    })
  )

export const taskCommentsCreateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      content: z.string().min(1),
    })
  )
  .output(taskCommentSchema)

export const taskCommentsDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      commentId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
